import React, { Component } from 'react';
import Question from './Question';
import Results from './Results';
import questions from './questions.json';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import sum from 'lodash/sum';
import isEmpty from 'lodash/isEmpty';
import getResultMessage from './getResultMessage';
import './App.css';

const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmail = text => !!text.match(emailPattern);

function onEnter(fn) {
  return e => {
    if (e.keyCode === 13) {
      fn();
    }
  }
}

function sendEmail(data) {
  const request = new XMLHttpRequest();
  request.open('POST', 'http://www.leathgroup.com/assessment-results');
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  request.send('data=' + btoa(unescape(encodeURIComponent(JSON.stringify(data)))));
}

function sendEmails(name, email, score) {
  const message = `
Thank you for taking the Strategic Mind Self-Assessment.
Your participation in this assessment is indicative of a learning mindset. Congratulations—this, in and
of itself, is a key step in becoming a more exemplary strategist.

${getResultMessage(score)}

Connect with us here:
http://www.leathgroup.com/connect
  `;

  // To the user
  sendEmail({
    subject: 'Strategic Mind self-assessment results',
    text: message,
    to: email,
    from: 'connect@leathgroup.com'
  });

  // To the admin
  sendEmail({
    subject: `Strategic Mind self-assessment results for ${name}`,
    text: `Score: ${score}, Email: ${email}`,
    to: 'blake@leathgroup.com',
    from: 'connect@leathgroup.com'
  });
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: Array(questions.length).fill(3),
      score: null,
      name: '',
      email: '',
      submitting: false,
      touched: {}
    };
  }
  handleChange(index, val) {
    const answers = [...this.state.answers];
    answers[index] = val;
    this.setState({ answers });
  }
  getScore = () => {
    if (isEmpty(this.state.name) || isEmpty(this.state.email) || !isEmail(this.state.email)) {
      return this.setState({
        touched: {
          name: true,
          email: true
        }
      });
    }
    this.setState({
      submitting: true
    });
    setTimeout(() => {
      this.setState({
        score: sum(this.state.answers),
      }, () => {
        sendEmails(this.state.name, this.state.email, this.state.score);
      });
    }, 1000);
  }
  renderQuestions() {
    return questions.map((text, index) => {
      return (
        <Question
          key={`question-${index}`}
          text={text}
          value={this.state.answers[index]}
          onChange={(e, val) => this.handleChange(index, val)}
        />
      );
    });
  }
  handleTextChange = field => (e, val) => {
    this.setState({
      touched: {
        ...this.state.touched,
        [field]: true
      },
      [field]: val,
    });
  }
  renderCheckmark() {
    if (this.state.submitting) {
      return (
        <FontIcon
          className="material-icons"
        >done</FontIcon>
      );
    }
  }
  renderForm = () => {
    return (
      <div className="form">
        {this.renderCheckmark()}
        <TextField
          floatingLabelText="Your Name"
          onChange={this.handleTextChange('name')}
          errorText={isEmpty(this.state.name) && this.state.touched.name ? "Name is required" : null}
        />
        <TextField
          floatingLabelText="Your Email"
          type="email"
          onChange={this.handleTextChange('email')}
          errorText={(isEmpty(this.state.email) || !isEmail(this.state.email)) && this.state.touched.email ? "Email is not valid" : null}
          onKeyUp={onEnter(this.getScore)}
        />
        <RaisedButton
          label="Get Score"
          fullWidth
          primary
          className="button"
          onClick={this.getScore}
        />
      </div>
    );
  }
  render() {
    return (
      <div className="App">
        <div className="header">
          <h1>Cultivating the Strategic Mind:</h1>
          <h2>FREE Strategist<br />Self-Assessment</h2>
          {
            this.state.score ? null :
            <small>For each statement below, rate the extent to which it is most like you (5) or least like you (1).</small>
          }
        </div>
        {this.state.score ? null : this.renderQuestions()}
        {this.state.score ? null : this.renderForm()}
        {this.state.score ? <Results name={this.state.name} score={this.state.score} /> : null }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js